module.exports = __webpack_public_path__ + "img/200704.ed6dc53b.jpg";